import React from "react";
import { LucideIcon } from "lucide-react";

interface QuickActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
}

const QuickActionButton = ({
  icon: Icon,
  label,
  onClick,
}: QuickActionButtonProps) => {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center justify-center bg-[#885ABB] text-white h-24 rounded-xl shadow-md hover:bg-[#7748A4] transition duration-300"
    >
      <Icon className="w-6 h-6" />
      <span className="text-sm font-medium mt-1">{label}</span>
    </button>
  );
};

export default QuickActionButton;
